import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import StatusBar from './components/StatusBar';
import ContentWindow from './components/ContentWindow';
import MessageBar from './components/MessageBar';
import AiTile from './components/AiTile';
import './App.css';

// A wrapper component to handle view state changes
const AppContent = ({ isDarkTheme, handleThemeToggle }) => {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 800);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (isLoading) {
    return (
      <div className="loading">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="App">
      <StatusBar
        isDarkTheme={isDarkTheme}
        handleThemeToggle={handleThemeToggle}
      />

      <Routes>
        <Route path="/" element={
          <>
            <ContentWindow />
            <MessageBar />
          </>
        } />
        <Route path="*" element={
          <>
            <ContentWindow />
            <MessageBar />
          </>
        } />
      </Routes>
    </div>
  );
};

function App() {
  // Always use light mode
  const [isDarkTheme, setIsDarkTheme] = useState(false);

  useEffect(() => {
    // Always use light mode regardless of saved theme
    document.body.classList.remove('dark-theme');
    localStorage.setItem('theme', 'light');
  }, []);

  // Theme toggle function (not active, but kept for compatibility)
  const handleThemeToggle = () => {
    // Do nothing - theme switching is disabled
    // Keep the function for compatibility with components
    return;
  };

  return (
    <Router>
      <AppContent isDarkTheme={isDarkTheme} handleThemeToggle={handleThemeToggle} />
    </Router>
  );
}

export default App;
